import AxiosWrapper from '@/helpers/axios-wrapper'


/**
 * @returns Promise
 */
export function list() {
    return AxiosWrapper('/clients/account/params/list/', {});
}

/**
 * @returns Promise
 */
export function detail() {
    return AxiosWrapper('/clients/account/params/detail/', {});
}

/**
 * @returns Promise
 */
export function remove(formData) {
    return AxiosWrapper('/clients/account/params/remove/', {headers: {"Content-Type": "multipart/form-data"}}, 'POST', formData);
}